import { t } from 'i18next'
import React, { useContext } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { Spinner } from 'reactstrap'
import mailIcon from '../../assets/mail-send-icon.svg'
import { ButtonBlue } from '../../components/Buttons/ButtonBlue'
import { ButtonWhite } from '../../components/Buttons/ButtonWhite'
import { CustomAlert } from '../../components/CustomAlert/CustomAlert'
import LoginContext from '../../context/LoginContext/LoginContext'

const ReSendMail = () => {
    const { loginState, reSendResetPassword } = useContext(LoginContext);
    const { forgotPassword } = loginState;

    const navigate = useNavigate()

    return forgotPassword.user === null ?
        <Navigate to="/login" replace />
        :
        (
            <div className='d-flex flex-column align-items-center gap-4 text-center me-4 ms-4'>
                {forgotPassword.error ? <CustomAlert text={forgotPassword.message} color={'danger'} /> : null}
                <div><img src={mailIcon} alt="" /></div>
                <h6 className='custom-h4'>{t('CHECK_YOUR_MAIL')}</h6>

                <p className='blue-dark-text-two'>
                    {t('WE_SEND_A_MAIL_TO')} <span className='fw-bold'>{forgotPassword.user.mail}</span> {t('FOR_RESET_PASSWORD')}
                </p>
                <div>
                    <p>{t('DID_NOT_ARRIVE_THE_MAIL')}</p>
                    <span>{t('REMEMBER_CHECK_SPAM')}</span>
                </div>
                <ButtonBlue className='w-100' onClick={()=>reSendResetPassword(forgotPassword.user)}>
                    {forgotPassword.wasReSend ? <i className="fa-solid fa-check pe-1"></i> : null}
                    {
                        forgotPassword.isFetching ?
                            <div className="d-flex justify-content-center">
                                <Spinner color='light' />
                            </div>
                            :
                            forgotPassword.wasReSend ?
                                t('WAS_SEND')
                                :
                                t('RESEND_MAIL')

                    }
                </ButtonBlue>
                <ButtonWhite className='w-100 shadow-none' onClick={()=>navigate('/recoverPassword')}>
                    {t('CHANGE_MAIL')}
                </ButtonWhite>
            </div>
        )
}

export default ReSendMail